<script>
    import { onMount } from 'svelte';

    let { cookieName = 'gdpr', heading = '', description = '', onanalytics, onmarketing, ontracking } = $props();

    let shown = $state(false);

    onMount(() => {
        shown = !getCookie(cookieName);
    });

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }

    function setCookie(name, value, days = 365) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
    }

    function accept() {
        setCookie(cookieName, 'true');
        shown = false;
        onanalytics?.();
        onmarketing?.();
        ontracking?.();
    }
</script>

{#if shown}
    <div class="gdpr-banner">
        <div class="gdpr-content">
            {#if heading}<h4>{heading}</h4>{/if}
            {#if description}<p>{description}</p>{/if}
            <button class="button primary" onclick={accept}>Close</button>
        </div>
    </div>
{/if}

<style>
    .gdpr-banner {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.9);
        color: #fff;
        padding: 1rem;
        text-align: center;
    }
    .gdpr-content {
        max-width: 800px;
        margin: 0 auto;
    }
    .gdpr-content h4 {
        margin: 0 0 0.5rem;
        color: #fff;
    }
    .gdpr-content p {
        margin: 0 0 0.75rem;
        font-size: 0.9rem;
        opacity: 0.9;
    }
    .gdpr-content button {
        min-width: 120px;
    }
</style>
